<template>
    <div>
        <div class="row">
            <b-col sm="10">
                <p class="mb-1">{{ data.legal_form }} {{ data.name }}</p>
                <p class="mb-1">{{ data.formatted_address }}</p>
                <p class="mb-3">
                    RCS {{ data.registration_city }}
                    {{ data.registration_number }}
                </p>
            </b-col>
            <b-col sm="2 text-right">
                <b-button
                    variant="secondary"
                    size="sm"
                    title="Modifier la personne morale"
                    @click="editMoralPerson"
                >
                    <i class="fas fa-pencil fa-fw"></i>
                </b-button>
            </b-col>
        </div>

        <div v-for="chief in chiefs" :key="chief.id">
            <p class="mb-1 small font-weight-bold text-uppercase">
                {{ chief.chief_title }}
            </p>
            <b-card v-if="chiefs.length > 0" no-body class="shadow-sm mb-3">
                <b-card-body>
                    <physical-person-data
                        v-if="chief.chief_type === 'physical'"
                        :data="chief.chief_data"
                        :editable="true"
                        :link-type="linkType"
                    />
                    <hr v-if="chief.chief_type === 'moral'" />
                    <moral-person-data
                        v-if="chief.chief_type === 'moral'"
                        :data="chief.chief_data"
                        :link-type="linkType"
                    />
                </b-card-body>
            </b-card>
        </div>
    </div>
</template>

<script>
import PhysicalPersonData from '../physicalPersons/PhysicalPersonData'

export default {
    name: 'MoralPersonData',

    components: { PhysicalPersonData },

    props: {
        data: {},
        linkType: {
            type: String,
            default: '',
        },
    },

    computed: {
        chiefs() {
            return 'chiefs' in this.data ? this.data.chiefs.data : []
        },
        /*
                legalFormTitle() {
                    return this.data.legal_form === null
                        ? ''
                        : this.data.legal_form.title
                }

         */
    },

    methods: {
        editMoralPerson() {
            if (this.linkType) {
                this.$store.commit('legalVM/SET_LINK_TYPE', this.linkType)
            }
            this.$store.commit('legalVM/SET_PERSON_ID', this.data.id)
            this.$store.commit('legalVM/SET_PERSON_TYPE', 'moral')
            this.$store.commit('legalVM/SHOW_EDIT')
        },
    },
}
</script>

<style scoped></style>
